/**
 * Shared geolocation utilities
 * Single source of truth for distance calculations and coordinate helpers
 */

/**
 * Calculate distance between two coordinates using the Haversine formula
 * @param {number} lat1 - Latitude of point 1
 * @param {number} lon1 - Longitude of point 1
 * @param {number} lat2 - Latitude of point 2
 * @param {number} lon2 - Longitude of point 2
 * @returns {number} Distance in kilometers
 */
export function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Earth's radius in kilometers
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

/**
 * Convert degrees to radians
 * @param {number} deg
 * @returns {number}
 */
export function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

/**
 * Zimbabwe geographic bounds
 */
export const ZIMBABWE_BOUNDS = {
  north: -15.6,
  south: -22.5,
  east: 33.1,
  west: 25.2
};

/**
 * Check if coordinates are within Zimbabwe
 * @param {number} lat
 * @param {number} lng
 * @returns {boolean}
 */
export function isWithinZimbabwe(lat, lng) {
  return (
    lat >= ZIMBABWE_BOUNDS.south &&
    lat <= ZIMBABWE_BOUNDS.north &&
    lng >= ZIMBABWE_BOUNDS.west &&
    lng <= ZIMBABWE_BOUNDS.east
  );
}

/**
 * Generate a Google Maps link for coordinates
 * @param {number} lat
 * @param {number} lon
 * @returns {string}
 */
export function getMapLink(lat, lon) {
  return `https://www.google.com/maps?q=${lat},${lon}`;
}
